<template>
  <div class="animated fadeIn">
    <b-card size="sm" footer-bg-variant="white" footer-border-variant="white">
      <div slot="header"><i class="icon-note"></i> Konsumen Detail</div>

      <b-card-body>
        <div>
          <b-form id="employeeForm" validated novalidate>
            <div v-if="loading == false">
              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Konsumen">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.name"
                      readonly
                      placeholder="Nama Konsumen"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Nama Pemilik">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.owner_name"
                      readonly
                      placeholder="Nama Pemilik"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="6">
                  <b-form-group label-for="name" label="KTP Number">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.ktp_number"
                      readonly
                      placeholder="KTP Number"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Handphone">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.handphone"
                      readonly
                      placeholder="Handphone"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Handphone 2">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.handphone2"
                      readonly
                      placeholder="Handphone 2"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Handphone 3">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.handphone3"
                      readonly
                      placeholder="Handphone 3"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                
              </b-row>

              <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Provinsi">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.province_name"
                      readonly
                      placeholder="Provinsi"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Kota/Kabupaten">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.regencies_name"
                      readonly
                      placeholder="Kota/Kabupaten"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Kecamatan">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.district_name"
                      readonly
                      placeholder="Kecamatan"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>

                <b-col sm="3">
                  <b-form-group label-for="name" label="Kelurahan">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.villages_name"
                      readonly
                      placeholder="Kelurahan"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="6">
                  <b-form-group label-for="name" label="Lokasi Toko">
                    <GmapMap
                      :center="locationToko"
                      :zoom="10"
                      map-type-id="terrain"
                      style="height: 500px"
                    >
                      <GmapMarker
                        :key="1"
                        :title="'asd'"
                        :position="locationToko"
                      >
                        <GmapInfoWindow
                          :options="{ maxWidth: 300 }"
                          :position="locationToko"
                          :opened="true"
                        >
                          <div>{{ customerForm.name }}</div>
                        </GmapInfoWindow>
                      </GmapMarker>
                    </GmapMap>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Alamat Toko">
                    <b-form-textarea
                      id="address"
                      :rows="3"
                      :max-rows="6"
                      v-model="customerForm.address"
                      readonly
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Alamat KTP">
                    <b-form-textarea
                      id="address"
                      :rows="3"
                      :max-rows="6"
                      v-model="customerForm.ktp_address"
                      readonly
                    ></b-form-textarea>
                  </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Tanggal Insert">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.date_inserted"
                      readonly
                      placeholder="Kelurahan"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Mau Jadi Konsumen ?">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.status_name"
                      readonly
                      placeholder="Mau Jadi Konsumen ?"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
                <b-col sm="3">
                  <b-form-group label-for="name" label="Apakah Toko Menjual Frozen Food ?">
                    <b-form-input
                      id="name"
                      type="text"
                      v-model="customerForm.question_1"
                      readonly
                      placeholder="Apakah Toko Menjual Frozen Food ?"
                    ></b-form-input>
                    <b-form-invalid-feedback
                      >Nama Konsumen harus di isi.</b-form-invalid-feedback
                    >
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="3">
                  <b-form-group label-for="name" label="KTP">
                    <b-img
                      :src="urlAssets + customerForm.ktp_picture"
                      :thumbnail="true"
                    ></b-img>
                  </b-form-group>
                </b-col>
                <b-col lg="3">
                  <b-form-group label-for="name" label="Foto Jalanan Depan Toko">
                    <b-img
                      :src="urlAssets + customerForm.street_store_picture"
                      :thumbnail="true"
                    ></b-img>
                  </b-form-group>
                </b-col>
                <b-col lg="3">
                  <b-form-group label-for="name" label="Toko Tampak Depan">
                    <b-img
                      :src="
                        urlAssets + customerForm.front_store_picture
                      "
                      :thumbnail="true"
                    ></b-img>
                  </b-form-group>
                </b-col>
                <b-col lg="3">
                  <b-form-group label-for="name" label="Toko Tampak Kanan">
                    <b-img
                      :src="
                        urlAssets + customerForm.right_store_picture
                      "
                      :thumbnail="true"
                    ></b-img>
                  </b-form-group>
                </b-col>
                <b-col lg="3">
                  <b-form-group label-for="name" label="Toko Tampak Kiri">
                    <b-img
                      :src="
                        urlAssets + customerForm.left_store_picture
                      "
                      :thumbnail="true"
                    ></b-img>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col lg="12">
                  <div class="text-right">
                    <b-button type="button" size="sm" variant="danger" @click="back">
                      <i class="fa fa-undo"></i> Back </b-button
                    >&nbsp;
                  </div>
                </b-col>
              </b-row>
            </div>
          </b-form>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";
import globalTable from "../../templates/Table.vue";
import interfaces from "@/templates/_interfaces.js";
import custom_validation from "@/templates/_customValidation.js";
import { required, email } from "vuelidate/lib/validators";
import VueNotifications from "vue-notifications";
import * as moment from "moment";
import "moment/locale/id";
import { ModelSelect, MultiSelect } from "vue-search-select";
import assetPlacement from "./tabs/AssetPlacement";
import assetPlacementAlter from "./tabs/AssetPlacementAlter";
import documentCustomer from "./tabs/DocumentCustomer";
import assetReturn from "./tabs/AssetReturn";
import loading from "@/templates/Loading.vue";

import { gmapApi } from "vue2-google-maps";

export default {
  name: "customer",
  components: {
    globalTable,
    ModelSelect,
    MultiSelect,
    assetPlacement,
    documentCustomer,
    assetReturn,
    assetPlacementAlter,
    loading,
  },
  props: {
    tableDetail: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      urlAssets: "https://storage.googleapis.com/mbsstorage/",
      google: gmapApi,
      locationToko: null,
      myLocation: null,
      listSurveyDetail: [],
      loading: true,
      customerForm: interfaces.customer,
    };
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error",
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info",
    },
  },
  methods: {
    init: function (cust_id) {
      this.loading = true;
      this.getCustomerDetail(cust_id);
      this.isEdit = false;
    },
    getCustomerDetail(cust_id) {
      this.axios
        .get("web/noo/detail/" + cust_id)
        .then((response) => {
          this.customerForm = response.data.data;
          this.locationToko = {
            lat: this.customerForm.lat,
            lng: this.customerForm.lng,
          };
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    back: function () {
      this.$router.go(-1);
    },
    expired: function (error, title) {
      if (error.response.status === 401) {
        localStorage.clear();
        this.$router.push({ path: "/login" });
        this.showErrorNotification({
          title: "Token Expired",
          message: "Your session has been expired",
        });
      } else {
        this.showErrorNotification({
          title: title,
          message: error.response.data.message,
        });
      }
    },
  },
  mounted() {
    let route = this.$route.path.split("/");
    this.init(route[4]);
  },
};
</script>

<style>
</style>
